import React from 'react'
import { Panel, FormPanel, Button, Container, Label, Toolbar } from '@sencha/ext-modern'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { doGetSample } from 'tyan/reducers/actions'
import Message from 'tyan/components/Message'

const style = {
	outer: {
		backgroundColor: "#f5f5f5",
		padding: "10px",
	},
	innerContainer: {
		borderRadius: "10px",
		backgroundColor: "#ffffff",
		padding: "10px",
		width: "100%",
	},
	titleContainer: {
		borderBottom: "1px solid #f5f5f5",
	},
}
class DetailSample extends React.Component {
	state = {
		sample: null,
		errorMessage: null,
		sampleMessage: null
	}

	componentDidMount() {
		const { doGetSample, match: { params: { sampleID, itype } } } = this.props
		doGetSample({
			sampleID,
			itype,
			onEnd: ({ sample, errorMessage }) => {
				this.setState({ sample, errorMessage })
			}
		})
	}


	handleBack = () => {
		const { history, match: { params: { source } } } = this.props
		history.goBack()

	}


	handleClick = o => {
		if(o.statusName=="检测中")
		{
			location.hash = `/QYWX/DataEntryInfo/${o.sampleInspectionID}`
		}
		else
		{
			location.hash = `/QYWX/DataReviewInfo/${o.sampleInspectionID}`
		}		
	}

	render() {
		const { sample, errorMessage, sampleMessage } = this.state
		if (errorMessage) {
			return <Message text="数据加载失败" subText={errorMessage} />
		} else if (!sample) {
			return <Message text="数据加载中..." />
		}
		const panelProps = {
			height: "100%",
			margin: '0 0 0 0',
			padding: '0 0 0 0'
		}
		return (
			<Panel shadow layout="vbox" {...panelProps} style={{ backgroundColor: '#fefbe2' }}>
				<Container layout="fit" flex={4}>
					<FormPanel shadow padding="20">
						<FormPanel layout={{ type: 'vbox', align: 'center', pack: "start" }}>
							{sample && sample.testList.map((o, index) => {
								return (
									<Button key={index}
										ui="raised action"
										text={index + 1 + '.' + o.name} margin="5" width="100%" textAlign="left"
										handler={() => this.handleClick(o)}
									/>
								)
							})}
						</FormPanel>
					</FormPanel>
				</Container>
			</Panel>
		)
	}
}

const mapStateToProps = ({ }) => ({})

export default compose(
	connect(mapStateToProps, { doGetSample })
)(DetailSample)